import React, { Component } from "react"
import autobind from "class-autobind"
import { TextField } from "material-ui"
import strings from "../../../../localization/strings"
import AppStateStore from "../../../../stores/AppStateStore"
import * as api from "../../../../api"
import { IClientDocument, IMarketingInfo } from "../../../../models"

interface IProps {
    clientDoc: IClientDocument
    readOnly?: boolean
    updateClientDoc(clientDoc: IClientDocument): void
}

interface IState {
    landingPage: string
    utmSource: string
    utmMedium: string
    utmCampaign: string
    utmTerm: string
    utmContent: string
    adId: string
    adSetId: string
    campaignId: string
    adName: string
    adSetName: string
    campaignName: string
    placement: string
    siteSourceName: string
    clientDoc: IClientDocument
}

export default class AccountManagerClientTabMarketing extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            landingPage: this.gettingMarketingInfo("LandingPage"),
            utmSource: this.gettingMarketingInfo("UtmSource"),
            utmMedium: this.gettingMarketingInfo("UtmMedium"),
            utmCampaign: this.gettingMarketingInfo("UtmCampaign"),
            utmTerm: this.gettingMarketingInfo("UtmTerm"),
            utmContent: this.gettingMarketingInfo("UtmContent"),
            adId: this.gettingMarketingInfo("AdId"),
            adSetId: this.gettingMarketingInfo("AdsetId"),
            campaignId: this.gettingMarketingInfo("CampaignId"),
            adName: this.gettingMarketingInfo("AdName"),
            adSetName: this.gettingMarketingInfo("AdsetName"),
            campaignName: this.gettingMarketingInfo("CampaignName"),
            placement: this.gettingMarketingInfo("Placement"),
            siteSourceName: this.gettingMarketingInfo("SiteSourceName"),
            clientDoc: this.props.clientDoc,
        }
        autobind(this)
    }

    gettingMarketingInfo(propertyName: string) {
        return this.props.clientDoc && this.props.clientDoc.MarketingInfo && this.props.clientDoc.MarketingInfo[propertyName] ? this.props.clientDoc.MarketingInfo[propertyName] : ""
    }

    saveMarketingInfo() {
        const updatedClientDoc = this.state.clientDoc
        if (updatedClientDoc.MarketingInfo === null) {
            updatedClientDoc.MarketingInfo = {} as IMarketingInfo
        }
        updatedClientDoc.MarketingInfo["LandingPage"] = this.state.landingPage
        updatedClientDoc.MarketingInfo["UtmSource"] = this.state.utmSource
        updatedClientDoc.MarketingInfo["UtmMedium"] = this.state.utmMedium
        updatedClientDoc.MarketingInfo["UtmCampaign"] = this.state.utmCampaign
        updatedClientDoc.MarketingInfo["UtmTerm"] = this.state.utmTerm
        updatedClientDoc.MarketingInfo["UtmContent"] = this.state.utmContent
        updatedClientDoc.MarketingInfo["AdId"] = this.state.adId
        updatedClientDoc.MarketingInfo["AdsetId"] = this.state.adSetId
        updatedClientDoc.MarketingInfo["CampaignId"] = this.state.campaignId
        updatedClientDoc.MarketingInfo["AdName"] = this.state.adName
        updatedClientDoc.MarketingInfo["AdsetName"] = this.state.adSetName
        updatedClientDoc.MarketingInfo["CampaignName"] = this.state.campaignName
        updatedClientDoc.MarketingInfo["Placement"] = this.state.placement
        updatedClientDoc.MarketingInfo["SiteSourceName"] = this.state.siteSourceName

        AppStateStore.setProgressSnackbarContent("loading")
        api.updateClient(updatedClientDoc).then(res => {
            this.setState({ clientDoc: res.data as IClientDocument }, () => {
                this.props.updateClientDoc(this.state.clientDoc)
                AppStateStore.setProgressSnackbarContent("")
            })
        })
    }

    checkForDisable(propertyName: string) {
        const marketingInfo = this.props.clientDoc.MarketingInfo
        return marketingInfo && marketingInfo[propertyName] ? true : this.props.readOnly
    }

    render() {
        return (
            <div style={{ margin: "20px 30px 20px 30px" }}>
                <div style={{ display: "flex" }}>
                    <div style={{ paddingRight: 10 }}>
                        <TextField
                            floatingLabelText={strings.LandingPage}
                            value={this.state.landingPage}
                            onChange={(_e, landingPage) => this.setState({ landingPage })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("LandingPage")}
                        />
                        <TextField
                            floatingLabelText={strings.UTMSource}
                            value={this.state.utmSource}
                            onChange={(_e, utmSource) => this.setState({ utmSource })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("UtmSource")}
                        />
                        <TextField
                            floatingLabelText={strings.UTMMedium}
                            value={this.state.utmMedium}
                            onChange={(_e, utmMedium) => this.setState({ utmMedium })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("UtmMedium")}
                        />
                        <TextField
                            floatingLabelText={strings.UTMCampaign}
                            value={this.state.utmCampaign}
                            onChange={(_e, utmCampaign) => this.setState({ utmCampaign })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("UtmCampaign")}
                        />
                        <TextField
                            floatingLabelText={strings.UTMTerm}
                            value={this.state.utmTerm}
                            onChange={(_e, utmTerm) => this.setState({ utmTerm })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("UtmTerm")}
                        />
                        <TextField
                            floatingLabelText={strings.UTMContent}
                            value={this.state.utmContent}
                            onChange={(_e, utmContent) => this.setState({ utmContent })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("UtmContent")}
                        />
                        <TextField
                            floatingLabelText={strings.AdId}
                            value={this.state.adId}
                            onChange={(_e, adId) => this.setState({ adId })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("AdId")}
                        />
                        <TextField
                            floatingLabelText={strings.AdsetId}
                            value={this.state.adSetId}
                            onChange={(_e, adSetId) => this.setState({ adSetId })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("AdsetId")}
                        />
                    </div>
                    <div style={{ padding: "0px 10px" }}>
                        <TextField
                            floatingLabelText={strings.CampaignId}
                            value={this.state.campaignId}
                            onChange={(_e, campaignId) => this.setState({ campaignId })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("CampaignId")}
                        />
                        <TextField
                            floatingLabelText={strings.AdName}
                            value={this.state.adName}
                            onChange={(_e, adName) => this.setState({ adName })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("AdName")}
                        />
                        <TextField
                            floatingLabelText={strings.AdsetName}
                            value={this.state.adSetName}
                            onChange={(_e, adSetName) => this.setState({ adSetName })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("AdsetName")}
                        />
                        <TextField
                            floatingLabelText={strings.CampaignName}
                            value={this.state.campaignName}
                            onChange={(_e, campaignName) => this.setState({ campaignName })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("CampaignName")}
                        />
                        <TextField
                            floatingLabelText={strings.Placement}
                            value={this.state.placement}
                            onChange={(_e, placement) => this.setState({ placement })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("Placement")}
                        />
                        <TextField
                            floatingLabelText={strings.SiteSourceName}
                            value={this.state.siteSourceName}
                            onChange={(_e, siteSourceName) => this.setState({ siteSourceName })}
                            onBlur={this.saveMarketingInfo}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled={this.checkForDisable("SiteSourceName")}
                        />
                    </div>
                </div>
            </div>
        )
    }
}